/**
 * システムエラーの遷移情報
 */
export class SystemErrorTransit {
  /**
   * メッセージ
   */
  message: string = ""
}
